export default "__VITE_ASSET__CPUr0YP6__"